import { call, put } from 'redux-saga/effects';
import { AxiosError, AxiosResponse } from 'axios';

// Response / Request
import { Result } from '@models/common/resultResponse';
import { KeyValue } from '@/main/models/common';

// Redux
import { GetCompanyType, saveCompanyType, saveCompanyTypePublic } from './index';

// Api's
import { companyTypeApi } from '../../api';
import {
  errorBoundaryReduxSaga,
  renderErrorReduxSaga
} from '@/main/services/utils';

export function* getCompanyTypeSaga(action: GetCompanyType) {
  try {
    const response: AxiosResponse<Result<KeyValue[]>> = yield call(
      companyTypeApi.getDomain,
      action.payload
    );
    if (response.data.result) {
      yield put(saveCompanyType(response.data.result, false, null));
    }
  } catch (exception) {
    if (exception instanceof AxiosError) {
      const resultError = errorBoundaryReduxSaga(exception);
      renderErrorReduxSaga(resultError);

      yield put(saveCompanyType(null, true, resultError.messagesDataError));
    }
  }
}

export function* getCompanyTypePublicSaga() {
  try {
    const response: AxiosResponse<Result<KeyValue[]>> = yield call(
      companyTypeApi.getDomainPublic
    );
    if (response.data.result) {
      yield put(saveCompanyTypePublic(response.data.result, false, null));
    }
  } catch (exception) {
    if (exception instanceof AxiosError) {
      const resultError = errorBoundaryReduxSaga(exception);
      renderErrorReduxSaga(resultError);

      yield put(
        saveCompanyTypePublic(null, true, resultError.messagesDataError)
      );
    }
  }
}
